// Vue
import { Component, Vue, Watch } from "vue-property-decorator";
// Template
import template from "./template.vue";
// Base Module
import ModuleBase from "#/common/ModuleBase";
// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { SliderItemImage } from "#/modules/common/stage_module/slider_item_image/SliderItemImage";
import { SliderItemImageFader } from "#/modules/common/stage_module/slider_item_image_fader/SliderItemImageFader";
import { SliderItemVideo } from "#/modules/common/stage_module/slider_item_video/SliderItemVideo";
import { SliderItemAufbauplus } from "#/modules/common/stage_module/slider_item_aufbauplus/SliderItemAufbauplus";
import { Api } from "#/api";

Vue.component("SliderItemImage", SliderItemImage);
Vue.component("SliderItemImageFader", SliderItemImageFader);
Vue.component("SliderItemVideo", SliderItemVideo);
Vue.component("SliderItemAufbauplus", SliderItemAufbauplus);

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class StageModule extends ModuleBase {
  private activeIndex: number = -1;

  private finalSlides: any[] = [];

  private animated: boolean = true;

  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  @Watch("instance")
  public onInstanceChange() {
    this.recomputeSlides();
  }

  created() {
    this.recomputeSlides();
  }

  get instanceHash() {
    return this.hash(
      JSON.stringify(this.instance) + JSON.stringify(this.finalSlides)
    );
  }

  public onSlideChange(index) {
    this.activeIndex = index;
  }

  private hash(s) {
    let hash = 0,
      i,
      chr;
    if (s.length === 0) return hash;
    for (i = 0; i < s.length; i++) {
      chr = s.charCodeAt(i);
      hash = (hash << 5) - hash + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  }

  private async recomputeSlides() {
    let slides = <any[]>this.instance["slides"];

    let result: any[] = [];
    for (let i = 0; i < slides.length; i++) {
      let slide = slides[i];
      if (slide["type"] == "news") {
        let news = await Api.pageService.getNews(
          this.$store.page.page!.portal.id,
          this.instance["news"]["count"],
          0,
          true,
          this.instance["news"]["max_age_in_days"]
        );

        news.resultList.forEach((entry) => {
          let image = entry.news.content.image;
          if (
            this.getTranslatedImage(
              entry.news.content.image_top_news,
              "de",
              "large"
            )
          ) {
            image = entry.news.content.image_top_news;
          }

          let link = entry.basic.route
            .replace("{lang}", this.lang)
            .replace("{country}", this.country);
          if (
            entry.news.content.hasOwnProperty("alternativeLink") &&
            entry.news.content["alternativeLink"] &&
            entry.news.content["alternativeLink"]["href"]
          ) {
            link = "" + entry.news["content"]["alternativeLink"]["href"];
          }

          let newSlide = JSON.parse(JSON.stringify(slide));
          newSlide.headline = entry.news.content.title;
          newSlide.text = entry.news.content.excerpt;
          newSlide.image = image;
          if (entry.news.content.color) {
            newSlide["font-color"] = entry.news.content.color;
          }
          newSlide.button.buttonLink = {
            href: link,
            access_allowed: true,
          };
          result.push(newSlide);
        });
      } else {
        result.push(slide);
      }
    }

    this.finalSlides = result;
  }
}
